import { AssetReference, WIDGET_PROPERTY_PREFIX } from '@studio/domain';
export const codePropertyRegex = /^(html|css|ts|js)$/;
export function stripCustomPropertyPrefix(propertyName) {
    return propertyName.replace(WIDGET_PROPERTY_PREFIX, '');
}
export function applyCustomPropertyPrefix(propertyName) {
    if (propertyName.indexOf(WIDGET_PROPERTY_PREFIX) > -1) {
        return propertyName;
    }
    return `${WIDGET_PROPERTY_PREFIX}${propertyName}`;
}
export function hasWidgetReference(property) {
    return property.name === AssetReference.Widget;
}
export function isCustomProperty(property) {
    return property.name.indexOf(WIDGET_PROPERTY_PREFIX) > -1;
}
export function isWidgetCodeProperty(property) {
    return property.name !== undefined && property.name.match(codePropertyRegex) !== null;
}
export function getIframeIdFromEvent(mouseEvent) {
    var _a, _b, _c, _d, _e;
    const currentTarget = mouseEvent.currentTarget;
    if (!currentTarget) {
        return;
    }
    if (currentTarget.defaultView) {
        return (_b = (_a = currentTarget.defaultView) === null || _a === void 0 ? void 0 : _a.frameElement) === null || _b === void 0 ? void 0 : _b.id;
    }
    return (_e = (_d = (_c = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.ownerDocument) === null || _c === void 0 ? void 0 : _c.defaultView) === null || _d === void 0 ? void 0 : _d.frameElement) === null || _e === void 0 ? void 0 : _e.id;
}
export function translateOpenEventPosition(mouseEvent, widgetInstance) {
    if (!(widgetInstance === null || widgetInstance === void 0 ? void 0 : widgetInstance.instance)) {
        return {
            x: mouseEvent.clientX,
            y: mouseEvent.clientY
        };
    }
    const { x: widgetX, y: widgetY } = widgetInstance.instance;
    // mouseEvent.clientX and clientY values are relative to the iframe
    return {
        x: mouseEvent.clientX + widgetX,
        y: mouseEvent.clientY + widgetY
    };
}
